export default __webpack_public_path__ + "static/media/blog1.e3fe7719.jpg";